import React from 'react';

import {
  StepWizardActionContainer,
  StepWizardFieldWithBorder,
} from 'src/presentation/components/pages/email/components/StepWizardLayout';
import { Button } from 'src/presentation/components/agent_desktop_components';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import { StyledBold } from './shared/elements';
import { formatPhone } from 'src/actions/shared/phonesHelper';

const PhoneNumberPurchased = ({ nextStep, phoneNumber }: { nextStep?; phoneNumber: string }): JSX.Element | null => {
  return (
    <>
      <StepWizardFieldWithBorder>
        <H3 data-aid="wizard-title">Phone number purchased</H3>
        <p>
          <StyledBold>{formatPhone(phoneNumber)}</StyledBold> is yours and has been added to Gladly. 🎉
        </p>
      </StepWizardFieldWithBorder>
      <StepWizardActionContainer>
        <Button data-aid="editor-save" type={Button.Types.PRIMARY} onClick={nextStep}>
          Next
        </Button>
      </StepWizardActionContainer>
    </>
  );
};

export default PhoneNumberPurchased;
